import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import TimeTargetOptionsPopUp from '../TimeTargetOptionsPopUp';
import TaskGeoTargetState from '../CheckGeotargetAccess/TaskGeoTargetState/TaskGeoTargetState';

class TaskPanelBodyAsExec extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTaskUpListPopUp: false
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.props.task.timeTarget ? (
          <TimeTargetOptionsPopUp
            id={`timeTargetInfo-task${this.props.task.id}`}
            timeTarget={this.props.task.timeTarget}
          />
        ) : null}
        <div className="row offset_bottom offset_bottom_xs">
          <div className="col-xs-24 col-sm-12">
            <dl className="dl-options dl-options-sm dl-horizontal task-options-left">
              <dt title={t('Категория')}>{t('Категория')}:</dt>
              <dd>{this.props.task.taskTypeDesc}</dd>
              <dt title={t('Проверка')}>{t('Проверка')}:</dt>
              <dd>{this.props.task.checkTypeDesc}</dd>
              <dt title={t('Многоразовость')}>{t('Многоразовость')}:</dt>
              <dd>{this.props.task.executorExecutionIntervalDesc}</dd>
            </dl>
          </div>
          <div className="col-xs-24 col-sm-12">
            <dl className="dl-options dl-options-sm dl-horizontal task-options-right">
              <dt title={t('Время выполнения')}>{t('Время выполнения')}:</dt>
              <dd>{this.props.task.timePerformDesc}</dd>
              <dt title={t('Таргетинг по времени')}>
                {t('Таргетинг по времени')}:
              </dt>
              <dd>
                {this.props.task.timeTarget &&
                this.props.task.timeTarget.length > 0 ? (
                  <a
                    data-toggle="modal"
                    href={`#timeTargetInfo-task${this.props.task.id}`}
                  >
                    {t('<span class="text-success">Есть</span>, узнать')}
                  </a>
                ) : (
                  <React.Fragment>{t('Нет')}</React.Fragment>
                )}
              </dd>
              <dt title={t('Геотаргетинг')}>{t('Геотаргетинг')}:</dt>
              <dd>
                <TaskGeoTargetState task={this.props.task} />
              </dd>
            </dl>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TaskPanelBodyAsExec.defaultProps = {
  refreshTaskItem: () => {}
};

TaskPanelBodyAsExec.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    taskTypeDesc: PropTypes.string.isRequired,
    checkTypeDesc: PropTypes.string.isRequired,
    executorExecutionIntervalDesc: PropTypes.string.isRequired,
    timePerformDesc: PropTypes.string.isRequired,
    tasksExecsStat: PropTypes.shape({}).isRequired,
    maxExecutions: PropTypes.number.isRequired,
    timeTarget: PropTypes.arrayOf(PropTypes.shape).isRequired,
    hasGeoTarget: PropTypes.bool.isRequired,
    upListFastenNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    updatedAt: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(TaskPanelBodyAsExec);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskPanelBodyAsExec/TaskPanelBodyAsExec.js